// src/services/fileParser.js - Updated to use Python parsing service



import mammoth from 'mammoth';



import cacheService from './cacheService';







class FileParser {



  constructor() {



    // Configure Python parser service URL; '' means same-origin (dev proxy only)



    // In production, ensure REACT_APP_PARSER_URL or REACT_APP_API_BASE_URL points to your backend



    const base = (



      process.env.REACT_APP_PARSER_URL ||



      process.env.REACT_APP_API_BASE_URL ||



      ''



    ).replace(/\/$/, '');



    this.pythonParserUrl = base; // '' or 'https://your-backend'



  }



  



  async parseFile(file, options = {}) {



    console.log('FileParser: Starting file parsing for:', file.name);







    // Disable caching to always get fresh results



    // const cacheKey = await cacheService.generateCacheKey(file);



    // const cachedResult = cacheService.get(cacheKey);







    // if (cachedResult) {



    //   console.log('FileParser: Using cached result for:', file.name);



    //   return cachedResult;



    // }







    const fileType = this.getFileType(file);







    try {



      let result;



      switch (fileType) {



        case 'powerpoint':



          result = await this.parsePowerPointWithPython(file, options);



          break;



        case 'word':



          result = await this.parseWord(file);



          break;



        case 'text':



          result = await this.parseText(file);



          break;



        case 'pdf':



          result = await this.parsePDF(file);



          break;



        default:



          throw new Error(`Unsupported file type: ${file.type}`);



      }







      // Disable caching to always get fresh results



      // cacheService.set(cacheKey, result);



      return result;







    } catch (error) {



      console.error(`Error parsing ${fileType} file:`, error);



      return this.createInformedFallback(file, error);



    }



  }







  getFileType(file) {



    const extension = file.name.split('.').pop().toLowerCase();



    const mimeType = file.type.toLowerCase();



    



    if (extension === 'ppt' || extension === 'pptx' || mimeType.includes('presentation')) {



      return 'powerpoint';



    } else if (extension === 'doc' || extension === 'docx' || mimeType.includes('document')) {



      return 'word';



    } else if (extension === 'txt' || mimeType.includes('text')) {



      return 'text';



    } else if (extension === 'pdf' || mimeType.includes('pdf')) {



      return 'pdf';



    }



    



    return 'unknown';



  }







  async parsePowerPointWithPython(file, options = {}) {



    console.log('Parsing PowerPoint with Python service:', file.name);







    try {



      // First check if Python service is available with timeout



      const healthCheckController = new AbortController();



      const healthCheckTimeout = setTimeout(() => healthCheckController.abort(), 5000); // 5 second timeout







      const healthCheck = await fetch(`${this.pythonParserUrl}/health`.replace(/^\//, '/'), {



        signal: healthCheckController.signal



      }).finally(() => clearTimeout(healthCheckTimeout));







      if (!healthCheck.ok) {



        throw new Error('Python parsing service unavailable');



      }







      // Send file to Python service with timeout



      const formData = new FormData();



      formData.append('file', file);

      // Add hasVideos flag if present
      if (options.hasVideos) {
        formData.append('hasVideos', 'true');
        console.log('🎬 Video mode enabled - will skip LibreOffice thumbnails');
      }

      // Add fastMode flag (default to true if not specified)
      const fastMode = options.fastAnalysis !== false;
      formData.append('fastMode', fastMode.toString());
      console.log(`🚀 Fast mode: ${fastMode} - ${fastMode ? 'Generating first 3 thumbnails only' : 'Generating ALL thumbnails'}`);







      const parseController = new AbortController();



      const parseTimeout = setTimeout(() => parseController.abort(), 600000); // 10 minute timeout for parsing large presentations







      const response = await fetch(`${this.pythonParserUrl}/parse-pptx`.replace(/^\//, '/'), {



        method: 'POST',



        body: formData,



        signal: parseController.signal



      }).finally(() => clearTimeout(parseTimeout));







      if (!response.ok) {



        const errorData = await response.json().catch(() => ({}));



        throw new Error(`Python parser error: ${response.status} - ${errorData.error || 'Unknown error'}`);



      }







      const result = await response.json();



      



      // Validate we got actual content (not XML garbage)



      if (!result.text_content || result.text_content.length < 50) {



        throw new Error('Python parser returned insufficient content');



      }







      console.log('✅ Python parsing successful. Content preview:', result.text_content.substring(0, 200));



      



      return {



        slideCount: result.slide_count,



        textContent: result.text_content,



        slides: result.slides, // Detailed slide breakdown



        metadata: {



          ...result.metadata,



          parseMethod: 'Python python-pptx service'



        }



      };



      



    } catch (error) {
      const rawMessage = error && error.message ? error.message : 'Unknown error';
      console.warn('Python parsing failed:', rawMessage);

      const isTimeout =
        error.name === 'AbortError' ||
        /timed out/i.test(rawMessage) ||
        /abort/i.test(rawMessage);
      const timeoutMessage = isTimeout
        ? 'Request to the parsing service timed out before a response was received. '
        : '';

      const serviceMessage = isTimeout ? '' : `Python service error: ${rawMessage}\n`;
      const guidance = this.pythonParserUrl
        ? `Backend base URL detected: ${this.pythonParserUrl}`
        : 'No backend base URL detected. Set REACT_APP_PARSER_URL (or REACT_APP_API_BASE_URL) to your backend URL in Netlify env and redeploy.';

      throw new Error(`PowerPoint parsing failed.\n\n${timeoutMessage}${serviceMessage}${guidance}\n\nTroubleshooting steps:\n1. Ensure your backend is running and accessible at /health and /parse-pptx\n2. Set REACT_APP_PARSER_URL on Netlify to your Render URL\n3. Convert to PDF or export plain text as a temporary workaround.`);
    }



  }







  async parseWord(file) {



    try {



      const arrayBuffer = await file.arrayBuffer();



      const result = await mammoth.extractRawText({ arrayBuffer });



      const textContent = result.value;



      



      return {



        slideCount: null,



        textContent: textContent,



        metadata: {



          colors: this.extractColors(textContent),



          fonts: this.extractFonts(textContent),



          hasImages: this.detectImages(textContent),



          bulletPointCount: this.countBulletPoints(textContent),



          parseMethod: 'Mammoth (Word)'



        }



      };



    } catch (error) {



      throw new Error(`Word document parsing failed: ${error.message}`);



    }



  }







  async parseText(file) {



    try {



      const textContent = await file.text();



      



      return {



        slideCount: null,



        textContent: textContent,



        metadata: {



          colors: [],



          fonts: [],



          hasImages: false,



          bulletPointCount: this.countBulletPoints(textContent),



          parseMethod: 'Direct text'



        }



      };



    } catch (error) {



      throw new Error(`Text file parsing failed: ${error.message}`);



    }



  }







  async parsePDF(file) {



    console.log('Parsing PDF with Python service:', file.name);



    try {



      // Verify backend availability with timeout



      const healthCheckController = new AbortController();



      const healthCheckTimeout = setTimeout(() => healthCheckController.abort(), 5000);







      const healthCheck = await fetch(`${this.pythonParserUrl}/health`.replace(/^\//, '/'), {



        signal: healthCheckController.signal



      }).finally(() => clearTimeout(healthCheckTimeout));







      if (!healthCheck.ok) {



        throw new Error('Python parsing service unavailable');



      }







      const formData = new FormData();



      formData.append('file', file);







      // Reuse the same endpoint; backend routes by file extension with timeout



      const parseController = new AbortController();



      const parseTimeout = setTimeout(() => parseController.abort(), 30000);







      const response = await fetch(`${this.pythonParserUrl}/parse-pptx`.replace(/^\//, '/'), {



        method: 'POST',



        body: formData,



        signal: parseController.signal



      }).finally(() => clearTimeout(parseTimeout));







      if (!response.ok) {



        const errorData = await response.json().catch(() => ({}));



        throw new Error(`Python parser error: ${response.status} - ${errorData.error || 'Unknown error'}`);



      }







      const result = await response.json();







      if (!result.text_content || result.text_content.length < 20) {



        throw new Error('Python parser returned insufficient content for PDF');



      }







      console.log('✅ PDF parsing successful. Content preview:', result.text_content.substring(0, 200));







      return {



        slideCount: result.slide_count,



        textContent: result.text_content,



        slides: result.slides || [],



        metadata: {



          ...result.metadata,



          parseMethod: 'Python PyPDF2 service'



        }



      };



    } catch (error) {



      console.warn('Python PDF parsing failed:', error.message);







      // Check if it was a timeout error



      const isTimeout = error.name === 'AbortError';



      const timeoutMessage = isTimeout ? 'Request timed out. ' : '';







      const guidance = this.pythonParserUrl



        ? `Backend base URL detected: ${this.pythonParserUrl}`



        : 'No backend base URL detected. Set REACT_APP_PARSER_URL (or REACT_APP_API_BASE_URL) to your backend URL in Netlify env and redeploy.';



      throw new Error(`PDF parsing failed.\n\n${timeoutMessage}Python service error: ${error.message}\n${guidance}\n\nOptions:\n1. Ensure your backend is running and accessible at /health and /parse-pptx\n2. Set REACT_APP_PARSER_URL on Netlify to your Render URL\n3. Export as plain text if needed as a temporary fallback.`);



    }



  }







  createInformedFallback(file, error) {



    return {



      slideCount: null,



      textContent: `File parsing failed for ${file.name}. \n\nError: ${error.message}\n\nFor PowerPoint files (.ppt/.pptx):\n1. Start Python parsing service: python simple_ppt_parser.py\n2. Or convert to PDF format\n3. Or export as plain text\n\nThis ensures you get your actual presentation content instead of XML metadata.`,



      metadata: {



        colors: [],



        fonts: [],



        hasImages: false,



        bulletPointCount: 0,



        parseMethod: 'Failed - service needed',



        fileName: file.name,



        fileSize: Math.round(file.size / 1024) + 'KB',



        originalError: error.message



      }



    };



  }







  // Helper methods



  extractColors(text) {



    const colorRegex = /#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})/g;



    return [...new Set((text || '').match(colorRegex) || [])];



  }







  extractFonts(text) {



    const fontNames = ['Arial', 'Helvetica', 'Times', 'Calibri', 'Verdana', 'Georgia', 'Tahoma'];



    const found = fontNames.filter(font => 



      (text || '').toLowerCase().includes(font.toLowerCase())



    );



    return found.length > 0 ? found : [];



  }







  detectImages(text) {



    const imageKeywords = ['image', 'picture', 'photo', 'graphic', 'chart', 'diagram'];



    return imageKeywords.some(keyword => 



      (text || '').toLowerCase().includes(keyword)



    );



  }







  countBulletPoints(text) {



    const bulletRegex = /[\u2022\u2023\u25E6\u2043\u2219]/g;



    const dashRegex = /^\s*[-*]\s/gm;







    const content = text || '';



    const bullets = (content.match(bulletRegex) || []).length;



    const dashes = (content.match(dashRegex) || []).length;







    return bullets + dashes;



  }



}







export default FileParser;



